<template>
  <div id="app" :class="{'accessibility-mode': isAccessibilityMode}">
    <div class="wrapper">
      <Header v-if="!hideSiteChrome" />
      <div class="main" :class="{ 'main--full-bleed': hideSiteChrome }">
        <router-view></router-view>
        <WidgetComponent v-if="!hideSiteChrome"/>
      </div>
      <Footer v-if="!hideSiteChrome" />
    </div>
  </div>
</template>

<script>
  import Header from "./components/Header.vue";
  import Footer from "@/components/Footer.vue";

  const UHPV_JQUERY = "https://lidrekon.ru/slep/js/jquery.js";
  const UHPV_FULL = "https://lidrekon.ru/slep/js/uhpv-full.min.js";

  export default {
    name: "App",
    data() {
      return {
        isAccessibilityMode: false,
        observer: null,
      };
    },
    components: {
      Footer,
      Header,
    },
    computed: {
      hideSiteChrome() {
        return !!(this.$route && this.$route.meta && this.$route.meta.hideSiteChrome);
      },
    },
    methods: {
      /** Vue-флаг только зеркалит DOM (#special / html.special) — без обхода uhpv. */
      syncAccessibilityMode() {
        const active = !!(
          document.getElementById("special") ||
          document.documentElement.classList.contains("special")
        );
        if (this.isAccessibilityMode !== active) {
          this.isAccessibilityMode = active;
        }
      },
      clearSpecialCookie() {
        document.cookie = "special=; path=/; Max-Age=0";
        document.cookie = "special=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
      },
      forceDisableAccessibility() {
        const panel = document.getElementById("special");
        const btn = document.getElementById("specialButton");
        if (panel && btn) {
          btn.click();
        }
        const stillOn = document.getElementById("special") ||
          document.documentElement.classList.contains("special");
        if (stillOn) {
          this.clearSpecialCookie();
          const leftover = document.getElementById("special");
          if (leftover && leftover.parentNode) {
            leftover.parentNode.removeChild(leftover);
          }
          const html = document.documentElement;
          html.classList.remove("special");
          Array.from(html.classList)
            .filter((c) => c.indexOf("special-") === 0)
            .forEach((c) => html.classList.remove(c));
          if (btn) {
            btn.style.display = "";
          }
        }
        this.syncAccessibilityMode();
      },
      loadScript(src, callback) {
        if (document.querySelector(`script[src="${src}"]`)) {
          if (typeof callback === "function") {
            callback();
          }
          return;
        }
        const script = document.createElement("script");
        script.src = src;
        script.onload = callback;
        script.onerror = () => {
          console.warn("Failed to load accessibility script:", src);
        };
        document.head.appendChild(script);
      },
      loadAccessibilityScripts() {
        this.loadScript(UHPV_JQUERY, () => {
          this.loadScript(UHPV_FULL, () => {
            this.observeAccessibilityMode();
            document.documentElement.style.display = "block";
            this.syncAccessibilityMode();
          });
        });
      },
      observeAccessibilityMode() {
        if (this.observer) {
          this.observer.disconnect();
        }
        this.observer = new MutationObserver(() => {
          this.syncAccessibilityMode();
        });
        this.observer.observe(document.documentElement, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["class"],
        });
        this.syncAccessibilityMode();
      },
    },
    mounted() {
      const start = () => this.loadAccessibilityScripts();
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", start, { once: true });
      } else {
        start();
      }
      this.$root.$on("forceDisableAccessibility", this.forceDisableAccessibility);
    },
    beforeDestroy() {
      this.$root.$off("forceDisableAccessibility", this.forceDisableAccessibility);
      if (this.observer) {
        this.observer.disconnect();
      }
    },
  };
</script>

<style lang="scss">
.accessibility-mode .header {
  margin-top: 50px;
}
.accessibility-mode .hide-in-accessibility {
  display: none;
}
.file-preview-image {
  max-width: 100px;
  max-height: 100px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.main--full-bleed {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
}
</style>
